import {SidebarComponent} from '../sidebar/sidebar.component';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {Router } from "@angular/router";
import { AuthService } from "../../login/services/auth.service";
import { DacConfig} from "../../shared/services/dac-config.service";
import { Role } from 'app/shared/models/role';
import { NavBarService } from 'app/theme/services/nav-bar.service';
import { NavBarItem } from '../models/nav-bar-item';

@Component({
  selector: 'dac-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
 
  @Input() doubleNav:Boolean;

  private _navItems:NavBarItem[];

  constructor(
    private authService:AuthService
    ,private dacConfig:DacConfig
    ,private router:Router
    ,private navService:NavBarService
  ) { 
    this._navItems = [];
    this.authService.getLoginState().subscribe(state => {
       let items = this.navService.topNavBarItemsForDisplay;
       if (items && items.length) {
         this._navItems = items;
       }
       else {
         this._navItems = [];
       }
    });
  }

  ngOnInit() {
  }
  ngOnDestroy(): void {
    // TODO: stephen this is a hack to cleanup after the MDB-navbar whenever we logout
    // we need to remove the fixed piece.
    let element = document.querySelector("body.fixed-sn");
    if (element) {
      element.classList.remove("fixed-sn");
    }
  }

  get navItems() {
    return this._navItems;
  }

  
  toggleSideNav() {
    this.navService.toggleSidebar();
  }

  handleItemClick(item:NavBarItem, $event:Event) {
    this.navService.handleMenuItemClick(item, $event);
  }

  get navClassString() {
    let navBarString = this.dacConfig.navBarClass;
    if (this.doubleNav) {
      return navBarString + " navbar fixed-top navbar-expand-sm double-nav";
    }
    else {
      return navBarString + " navbar navbar-expand-sm";
    }
  }

  get containerInside() {
    if (this.doubleNav) {
      return false;
    }
    else {
      return true;
    }
  }

  get logoUrl() {
    return this.dacConfig.applicationLogoUrl;
  }

  get logoTitle() {
    return this.dacConfig.applicationLogoTitle;
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/navbar/navbar.component.ts